import { useCallback } from 'react';
import { coreCallApi } from '@cp/entities/call';
import { useToast } from '@cp/shared/toast';
import { ClientType } from '@common/model/client/clientType';
import { getUserFromInteraction } from './getUserFromInteraction';
import { getActionErrorMessage, useInteractionDetails } from './useInteractionDetails';

/**
 * Starts a nanny-phone call to the specialist from a response-delay interaction.
 */
export const useStartCall = (interactionId: number) => {
  const toast = useToast();
  const { loadDetails, isLoading: isDetailsLoading } = useInteractionDetails(interactionId);
  const [startCallMutation, { isLoading: isCallLoading }] = coreCallApi.endpoints.startCall.useMutation();

  const startCall = useCallback(async () => {
    const detailsResult = await loadDetails();
    if (detailsResult.isErr) {
      toast('error', getActionErrorMessage(detailsResult.error));
      return;
    }
    const details = detailsResult.unwrap();
    const specialist = getUserFromInteraction(ClientType.Specialist, details);
    if (!details.subjectId || !specialist) {
      toast('error', 'Невозможно вызвать специалиста');
      return;
    }
    const callResult = await startCallMutation({ dialogId: details.subjectId, specialistId: specialist.id });
    if (callResult.error) {
      toast('error', getActionErrorMessage(callResult.error));
      return;
    }
    toast('success', 'Успешно');
  }, [loadDetails, startCallMutation, toast]);

  return { startCall, isLoading: isDetailsLoading || isCallLoading };
};
